import { useState, useEffect } from 'react';
import { UserOutlined } from '@ant-design/icons';
import { Tabs, Space } from 'antd';
import type { TabsProps } from 'antd';
import { Button, Form, Spin } from 'antd';
import CLIENT from '../../../Models/Client';
import axios from 'axios';
import Tab1 from './Tab1';
import Utilisateur from '../../../Models/Utilisateur';
import { useAuthHeader, useAuthUser } from '../../../Services/Auth/sessionAuth';
import Data from '../../../Data/Data.json'
import SweetAlert from "sweetalert2"
import { Crypter } from '../../../Functions/Security/Crypter';
import { Box, Typography } from '@mui/material';
import InputForm from '../../InputT';
import ReformatDate from '../../../Functions/Traitement/ReformatDate';
import { useNavigate } from 'react-router-dom';
import VerifDay from '../../../Functions/Traitement/VerifDay';

//import '../../../Assets/Styles/StyleForm.css';
//CreateNewCLIENT
const Swal = require('sweetalert2');
let Link = require('../../../Data/Data.json');

const ClientInterne = () => {
  // USER SESSION
  const auth = useAuthUser()
  const user: Utilisateur = JSON.parse(JSON.stringify(auth()))

  // USER TOKEN
  const authHeader = useAuthHeader()

  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [StartSearchG, SetStartSearchG] = useState(false);
  const [StartForm, SetStartForm] = useState(true);
  const [, forceUpdate] = useState({});
  const [isSubmit, setIsSubmit] = useState(false)
  const [ajoutActve, setAjoutActif] = useState(false)
  const [modifActve, setModifActve] = useState(true)
  const [enregActve, setEnregActve] = useState(true)
  const [supActive, setSupActive] = useState(true)
  const [impActive, setImpActive] = useState(true)
  const [actuActive, setActActive] = useState(true)
  const [annulActive, setAnnulActive] = useState(true)
  const [consulActive, setConsulActive] = useState(false)
  const [sbmit, setSbmit] = useState("");
  const Navigate=useNavigate();
  const [Load, SetLoad] = useState(false);

  useEffect(() => {
    forceUpdate({});
    if(Load===false)
    {
      VerifDay(user.coduti,user.codage,authHeader,Navigate);
      SetLoad(true);
     }
  }, []);

  function initialiazeButton() {
    setAjoutActif(false)
    setModifActve(true)
    setEnregActve(true)
    setSupActive(true)
    setImpActive(true)
    setActActive(true)
    setAnnulActive(true)
    setConsulActive(false)
  }

  const SetStart = () => {
    setSbmit("add")
    setAjoutActif(true)
    setEnregActve(false)
    setAnnulActive(false)
    setConsulActive(true)
    SetStartSearchG(true)
    form.resetFields()
    form.setFieldValue("niveau", 900)
  }

  const SetEndStart = () => {
    SetStartForm(true);
    SetStartSearchG(true)
  }

  function handleAnulle() {
    let coduti = form.getFieldValue("CODUTI")
    form.resetFields()
    localStorage.clear()
    form.setFieldValue("CODUTI", coduti)
    initialiazeButton()
    localStorage.setItem(Data.LocalVariable.reset, "1")
    //localStorage.setItem(Data.LocalVariable.resetTable, "1")
  }
  function cunsultButton() {
    setAnnulActive(false)
    setModifActve(false)

  }

  function modifButton() {
    setSbmit("update")
    setModifActve(true)
    setAjoutActif(true)
    setEnregActve(false)
    setConsulActive(true)
  }


  const items: TabsProps['items'] = [
    {
      key: '1',
      label: (
        <span id='Tab'>
          <UserOutlined />
          Information Client
        </span>
      ),
      children: <Tab1 etatG={StartSearchG} form={form} />,
    }]

  const onFinish = (values: any) => {
    var Client: CLIENT = values;
    Client.TYPCLI = "I";
    Client.UTILIS = user.coduti;
    Client.CODAGE=user.codage;

    // Client.DateDelcni = Client.DateDelcni? (new Date(Client.DateDelcni)).toLocaleDateString("fr").replaceAll('/', '-')+" 00:00:00" : ""
    // Client.DATNAI = (new Date(Client.DATNAI)).toLocaleDateString("fr").replaceAll('/', '-')+" 00:00:00"

    console.log(Client);


    if (sbmit == "add") {
      
      Client.DATCRE=(new Date(user.datjour)).toLocaleDateString("fr").replaceAll("/",'-');

      if (Client.NUMCLI.length !== 0) {
        SweetAlert.fire({
          title: "Enregistrement du client",
          text: "Voulez-vous enregistrer le client  " + Client.NOMCLI + " ?",
          showCancelButton: true,
          color: "#116599",
          confirmButtonText: "Yes",
          confirmButtonColor: "#116599",
          cancelButtonColor: "darkred",
          cancelButtonText: "No",
          showLoaderOnConfirm: true,
          icon: 'question'
        }).then((res) => {
          if (res.isConfirmed) {
            setLoading(true);
            setIsSubmit(true)
            //let group = profilsDistant.find(()=>)
            console.log('Received values of form: ', Crypter.encrypt(JSON.stringify(Client)));

            let data = Crypter.encrypt(JSON.stringify(Client));

            let config = {
              method: 'post',
              maxBodyLength: Infinity,
              url: Data.ApiUrl.CreateNewCLIENT,
              headers: {
                // 'CypherClient': data,
                'Authorization': authHeader(),
                'Content-Type': 'application/json'
              },
              data:data
            };

            axios.request(config)
              .then((response) => {
                setLoading(false);
                if (response.data) {
                  const res = JSON.parse(Crypter.decrypt(response.data));

                  if (res.StatutCode == 200) {
                 
                    localStorage.clear()
                    setIsSubmit(false);
                    form.resetFields();
                    SweetAlert.fire({ title: res.Message, text: res.Result, icon: "success" });

                    localStorage.clear()
                    initialiazeButton();

                    setSbmit("");
                  }
                  else {
                    SweetAlert.fire({ title: res.Message, text: res.Result, icon: "error" })
                  }
                }
              })
              .catch((error) => {
                setLoading(false);
                console.log(error)
                SweetAlert.fire({ title: "Error", text: error, icon: "error" })
              });

          }
        })
      } else {
        SweetAlert.fire({ title: "Saisie Invalide", text: "le numéro de client doit étres sur 7 carréteres", icon: "error" })
      }
    }

    if (sbmit == "update") {

      Client.DATMAJ = (new Date(user.datjour)).toLocaleDateString("fr").replaceAll("/",'-');;
      //console.log(values)
      SweetAlert.fire({
        title: "Modification du Client",
        text: "Voulez-vous modifier le client " + Client.NUMCLI + " ?",
        showCancelButton: true,
        color: "#116599",
        confirmButtonText: "Yes",
        confirmButtonColor: "#116599",
        cancelButtonColor: "darkred",
        cancelButtonText: "No",
        showLoaderOnConfirm: true,
        icon: 'question'
      }).then((res) => {
        if (res.isConfirmed) {
          setLoading(true);
          setIsSubmit(true)

          console.log('Received values of form: ', Client);

          let data = Crypter.encrypt(JSON.stringify(Client));

          let config = {
            method: 'put',
            maxBodyLength: Infinity,
            url: Data.ApiUrl.UpdateClient,
            headers: {
              'Authorization': authHeader(),
              'Content-Type': 'application/json'
            },
            data:data
          };

          axios.request(config)
            .then((response) => {
              setLoading(false);
              if (response.data) {
                const res = JSON.parse(Crypter.decrypt(response.data));

                if (res.StatutCode == 200) {
                  let code = Client.NUMCLI
                  form.resetFields()
                  localStorage.clear()
                  setIsSubmit(false)
                  SweetAlert.fire({ title: res.Message, text: "Code : " + code, icon: "success" })

                  initialiazeButton()
                  localStorage.setItem(Data.LocalVariable.reset, '1')

                  setSbmit("")
                }
                else {
                  SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
                }
              }
            })
            .catch((error) => {
              setLoading(false);
              console.log(error)
              SweetAlert.fire({ title: "Error", text: error, icon: "error" })
            });
        }
      })
    }
  };

  const onFinishFailed = async (errorInfo: any) => {
    var errors: any = [];

    errorInfo.errorFields.map((error: any) => {

      errors.push(error.name + "");
    })

    SweetAlert.fire({ title: "Veuillez remplir tous les champs obligatoires", text: errors.toString().replaceAll(',', " - "), icon: 'warning', confirmButtonText: 'OK' })

  };

  function consult() {

    let data = Crypter.encrypt(form.getFieldValue("NUMCLI"));
    let clearNumcli = form.getFieldValue("NUMCLI");

    if (data.length != 0) {
      initialiazeButton()
      setLoading(true)
      form.resetFields()
      form.setFieldValue("NUMCLI", clearNumcli)
      let config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: Data.ApiUrl.GetClient,
        headers: {
          'CypherNumcli': data,
          'Authorization': authHeader(),
          'Content-Type': 'application/json'
        },
      };
      axios.request(config)
        .then((response) => {
          setLoading(false);
          if (response.data) {
            const res = JSON.parse(Crypter.decrypt(response.data));

            if (res.StatutCode == 200) {
              let datas: CLIENT = res.Result.Table[0]
              console.log(res)
              if (res.Result.Table.length > 0) {
                if (datas.TYPCLI.toUpperCase() == 'I') {
                  form.setFieldsValue(res.Result.Table[0]);
                  form.setFieldValue('lib_NUMCLI', datas.NOMCLI);
                  form.setFieldValue("lib_NUMCLI", form.getFieldValue("NOMCLI"));
                  form.setFieldValue("DATCRE", datas.DATCRE ? (new Date(datas.DATCRE.substring(0, 10))).toLocaleDateString("fr"):'' ) 

                  cunsultButton()
                  console.log(form.getFieldsValue())
                }
                else {
                  SweetAlert.fire({ title: "Warning", text: "Type de client non correspondant", icon: "warning" })
                }
              } else {
                SweetAlert.fire({ title: "Warning", text: "Client not found", icon: "warning" })
              }
            }
            else {
              SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
            }
          }
          setLoading(false)
        })
        .catch((error) => {
          setLoading(false);
          console.log(error)
          SweetAlert.fire({ title: "Error", text: error.message, icon: "error" })
        });
    }
  }
  function modif() {
    modifButton()

  }

  return (

    <div className='tab'>
      <Typography align='center' className='formTitle'><b>GESTION CLIENT INTERNE : {window.location.pathname.toUpperCase()}</b></Typography>
      <Spin spinning={loading} size='large' style={{ color: '#116599' }} >
        <Form disabled={!ajoutActve} autoComplete="off" labelAlign='left' form={form} name="dynamic_form_complex" onFinish={onFinish} onFinishFailed={onFinishFailed} style={{ minWidth: 'auto', maxWidth: 'auto' }}>
          <div className='bG'>
            <legend><Typography color={"#116599"}>Actions</Typography></legend>
            <Form.Item shouldUpdate className='bouttong'>
              <Space direction="vertical" style={{ width: '100%' }}>

                <Button size='large' className='bt_add' disabled={consulActive} onClick={consult} type="ghost" htmlType="button" block  >
                  Consulter
                </Button>

                <Button size='large' className='bt_add' disabled={ajoutActve} onClick={SetStart} type="ghost" htmlType="button" block  >
                  Ajouter
                </Button>
                <Button size='large' className='bt_add' disabled={modifActve} onClick={modif} type="ghost" htmlType="button" block  >
                  Modifier
                </Button>
                <Button size='large' className='bt_add' disabled={enregActve} type="ghost" htmlType="submit" block>
                  Enregistrer
                </Button>
                <Button size='large' className='bt_add' onClick={SetEndStart} disabled={supActive} type="ghost" htmlType="button" block>
                  Supprimer
                </Button>
                <Button size='large' className='bt_add' disabled={impActive} type="ghost" htmlType="button" block  >
                  Aperçu
                </Button>
                <Button size='large' className='bt_add' disabled={actuActive} type="ghost" htmlType="button" block  >
                  Actualiser
                </Button>
                <Button size='large' disabled={annulActive} onClick={handleAnulle} className='bt_add' type="ghost" htmlType="reset" block>
                  Annuler
                </Button>
              </Space>
            </Form.Item>
          </div>
          <div className='clientP'>
            <div >
              <Tabs size='large' type="card" defaultActiveKey="1" items={items} />
            </div>
            <Box display={"flex"} fontStyle="inherit" className='border-left bordure1 tabElement2'>
              <InputForm notRequired disabled taille={200} width={10} label='UTILISATEUR  CREER' name='UTILIS' defaultValue='' type='text' error='mobile' />
              {/* <InputForm notRequired disabled taille={200} width={10} label='UTILISATEUR  VALIDER' name='UTILVAL' defaultValue='' type='text' error='mobile' /> */}
              <InputForm notRequired disabled taille={200} width={10} label='DATE CREATION' name='DATCRE' defaultValue='' type='text' error='mobile' />
            </Box>
            <div>
            </div>
          </div>
        </Form>
      </Spin>
    </div>

  );
}
export default ClientInterne;